import React from "react";

import config from "config";

import { useFeatures } from "../../FeatureFlag";

export default function useRedtailUrl() {
  return useFeatures("redtail-url", config.redtailUrl);
}

export function withRedtailUrl(Component) {
  return (props) => {
    const redtailUrl = useRedtailUrl();
    return <Component {...props} redtailUrl={redtailUrl} />;
  };
}
